import { render, staticRenderFns } from "./VLOCR.vue?vue&type=template&id=ee2c81c4&scoped=true"
import script from "./VLOCR.vue?vue&type=script&lang=js"
export * from "./VLOCR.vue?vue&type=script&lang=js"
import style0 from "./VLOCR.vue?vue&type=style&index=0&id=ee2c81c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2c81c4",
  null
  
)

export default component.exports